/* eslint-disable react/no-danger */

import * as React from 'react';
import {Query} from 'react-apollo';

import {colors} from 'shells/colors/colors';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {ErrorMessage} from 'shells/form/error-message';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {Modal} from 'shells/modal/modal';

import type {
    GetConstantContactEmailCampaignActivityPreview as GetConstantContactEmailCampaignActivityPreviewQuery,
    ConstantContactEmailCampaignActivityPreview as ConstantContactEmailCampaignActivityPreviewFragment,
} from 'nutshell-graphql-types';

import GET_CONSTANT_CONTACT_EMAIL_CAMPAIGN_ACTIVITY_PREVIEW from '../graphql/queries/get-constant-contact-email-campaign-activity-preview.graphql';

import styles from './constant-contact-email-preview-modal.module.css';

type Props = {
    onClose: () => any;
    activityId: string;
};

class ConstantContactEmailCampaignActivityPreviewQuery extends Query<
    GetConstantContactEmailCampaignActivityPreviewQuery,
    Record<any, any>
> {}

export class ConstantContactEmailPreviewModal extends React.PureComponent<Props> {
    render() {
        return (
            <ConstantContactEmailCampaignActivityPreviewQuery
                query={GET_CONSTANT_CONTACT_EMAIL_CAMPAIGN_ACTIVITY_PREVIEW}
                variables={{id: this.props.activityId}}
            >
                {({data, loading}) => {
                    const preview = data ? data.constantContactEmailCampaignActivityPreview : null;

                    return (
                        <Modal
                            isOpen={true}
                            onClose={this.props.onClose}
                            headerText='Email preview'
                        >
                            <FlashBanner
                                animate={false}
                                type='info'
                                leftAlignContent={true}
                                hasBorder={true}
                            >
                                {`Below is a preview of the email ${
                                    preview ? `"${preview.subject}"` : ''
                                } you sent via Constant Contact.`}
                            </FlashBanner>
                            {this.renderModalContent(preview, loading)}
                        </Modal>
                    );
                }}
            </ConstantContactEmailCampaignActivityPreviewQuery>
        );
    }

    renderModalContent = (
        preview: ConstantContactEmailCampaignActivityPreviewFragment | null | undefined,
        isLoading: boolean
    ) => {
        if (preview) {
            return (
                <div
                    dangerouslySetInnerHTML={{
                        __html: preview.previewHtmlContent,
                    }}
                    className={styles['email-container']}
                />
            );
        }

        if (isLoading) {
            return (
                <div className={styles.container}>
                    <LoadingIcon fill={colors.offWhiteDk} />
                </div>
            );
        }

        return (
            <div className={styles.container}>
                <ErrorMessage>
                    Whoops! We couldn’t load that email, something went wrong.
                </ErrorMessage>
            </div>
        );
    };
}
